import React, { FC } from 'react'

// Styles
import { Image } from './Sidebar.styles'

// Images
import BeigeVariant from './sidebar-beige.png'
import BeigeVariant2x from './sidebar-beige@2x.png'
import GreenVariant from './sidebar-green.png'
import GreenVariant2x from './sidebar-green@2x.png'
import PurpleVariant from './sidebar-purple.png'
import PurpleVariant2x from './sidebar-purple@2x.png'
import TealVariant from './sidebar-teal.png'
import TealVariant2x from './sidebar-teal@2x.png'

// Utils
import { useForTablet } from 'components/Breakpoint'

// Types
export type Variant = 'teal' | 'green' | 'purple' | 'beige'

const Sidebar: FC<{ variant: Variant }> = ({ variant }) => {
  const isTabletAndBigger = useForTablet()

  const getVariantImage = (): { base: string; size2: string } | null => {
    switch (variant) {
      case 'beige': {
        return {
          base: BeigeVariant,
          size2: BeigeVariant2x,
        }
      }
      case 'green': {
        return {
          base: GreenVariant,
          size2: GreenVariant2x,
        }
      }
      case 'purple': {
        return {
          base: PurpleVariant,
          size2: PurpleVariant2x,
        }
      }
      case 'teal': {
        return {
          base: TealVariant,
          size2: TealVariant2x,
        }
      }
      default: {
        return null
      }
    }
  }

  const variantImage = getVariantImage()
  if (!variantImage || !isTabletAndBigger) return null

  return (
    <Image
      alt={`${variant}-image`}
      src={variantImage.base}
      srcSet={`${variantImage.size2} 2x`}
    />
  )
}

export default Sidebar
